import React, {Component} from 'react';
import moment from 'moment';

class LectureTimer extends Component {
    constructor(props){
        super(props);

        this.state = {
            userTime: -1,
            lastUpdatedTime: 10,
            startTime: new Date(),
            timerId: null,
            setTimer: false
        }

        this.timer = null;
    }

    componentDidMount(){
        this.initialize();
    }

    componentDidUpdate(props, state){
        if(props.lectureId !== this.props.lectureId){
            clearInterval(this.timer);
            this.setState({
                userTime: -1,
                lastUpdatedTime: 60,
                startTime: new Date(),
                timerId: null,
                setTimer: false
            }, () => {
                this.initialize();
            })
        }
        
    }

    initialize = () => {

        if (!this.state.timerId && !this.state.setTimer) {
            this.setState({setTimer: true, userTime: this.props.startTime}, () => {
                if (!this.timer) {
                    // Initiate lecture timer
                    this.timer = setInterval(this.updateTimer, 1000);
                    
                }
            })
        }
    }

    clearTimer = () => {
        clearInterval(this.timer);
    }

    componentWillUnmount = () => {
        clearInterval(this.timer);
    }

    updateTimer = () => {
        let {userTime, lastUpdatedTime} = this.state;
        if(!this.props.idle){
            userTime += 1;
            
            if(lastUpdatedTime === 0){
                lastUpdatedTime = 60;
                let currentTime = this.props.currentTime();

                if(currentTime){
                    if(currentTime.indexOf(":") > -1){
                        let splitTime = currentTime.split(":");
                        let minutes = parseInt(splitTime[0]) * 60;
                        let seconds = parseInt(splitTime[1]);
        
                        currentTime = minutes + seconds;
        
                    }
                    
                    let {courseUser, userLecture} = this.props;

                    
                    userLecture.currentTime = currentTime;
                    if(userLecture.completed === false){
                        userLecture.userTime = this.state.userTime;
                    }

                    if(userLecture.currentTime > userLecture.maxTime){
                        userLecture.maxTime = userLecture.currentTime;
                    }
                    userLecture.duration = this.props.getCurrentDuration();
                    
                    let today = moment().format('YYYY-MM-DD');
                    let existingDate = courseUser.studied.filter(d => d.date === today);
                    if(existingDate.length > 0){
                        existingDate[0].time += 60;
                    }else{
                        courseUser.studied.push({date: today, time: 60});
                    }

                    const ul = {
                        id: userLecture.id,
                        userTime: userLecture.userTime,
                        duration: userLecture.duration,
                        currentTime: userLecture.currentTime,
                        maxTime: userLecture.maxTime
                    }

                    const cu = {
                        id: courseUser.id,
                        studied: courseUser.studied
                    }
                    
                    if(!this.props.complete){
                        this.props.syncTaskProgress();
                        this.props.syncVideoTime(cu, ul, this.props.user.id);
                    }
                }
                
            }else{
                lastUpdatedTime -= 1;
            }
            
            this.setState({userTime, lastUpdatedTime});
        }
    }

    render(){
        if(this.props.show){
            let seconds = parseInt(this.state.userTime % 60);
            let timer = (seconds < 10) ? String(parseInt(this.state.userTime / 60)) + ":" + "0" + seconds.toString()
                : String(parseInt(this.state.userTime / 60)) + ":" + seconds.toString();

            return (
                <div>
                    {this.props.userLecture.completed === false ?
                        <div className={"timer"}>{timer}</div>
                    : null}
                </div>
            )
        }else{
            return null;
        }
    }
}

export default LectureTimer;


// WEBPACK FOOTER //
// ./src/components/Video/LectureTimer.js